<template>
  <transition name="locale-slide">
    <div class="locale-suggestion" v-if="visible">
      <span class="suggestion-text">Switch to English?</span>
      <div class="suggestion-actions">
        <el-button size="small" type="primary" @click="chooseEn">English</el-button>
        <el-button size="small" @click="chooseZh">中文</el-button>
      </div>
      <a href="#" class="suggestion-close" @click.prevent="dismiss">×</a>
    </div>
  </transition>
</template>

<script setup>
// 首次访问语言建议横幅：仅当无存储偏好且浏览器语言为英文时由 App.vue 挂载
// 用户任选其一都写入偏好；仅点 × 关闭则本次会话不再打扰（不写入存储）
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { LOCALE_EN, LOCALE_ZH } from '../locales';
import { setStoredLocale, localePath } from '../utils/locale';

const route = useRoute();
const router = useRouter();
const visible = ref(true);

const chooseEn = () => {
  setStoredLocale(LOCALE_EN);
  visible.value = false;
  router.push(localePath(route.path, LOCALE_EN));
};

const chooseZh = () => {
  setStoredLocale(LOCALE_ZH);
  visible.value = false;
};

const dismiss = () => {
  visible.value = false;
};
</script>

<style lang="scss" scoped>
.locale-suggestion {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);

  .suggestion-text {
    font-size: 14px;
    color: #333;
  }

  .suggestion-actions {
    display: flex;
    gap: 8px;
  }

  .suggestion-close {
    color: #999;
    font-size: 18px;
    line-height: 1;
    margin-left: 4px;

    &:hover {
      color: #333;
    }
  }
}

.locale-slide-enter-active,
.locale-slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.locale-slide-enter-from,
.locale-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
